<script setup lang="ts">
import type { NuxtError } from '#app'
import { computed } from 'vue'
import { Button } from '@/components/ui/button'

const props = defineProps<{ error: NuxtError }>()
const router = useRouter()

const is404 = computed(() => props.error.statusCode === 404)

function handleError() {
  if (is404.value) {
    router.back()
  }
  else {
    clearError({ redirect: '/dashboard' })
  }
}
</script>

<template>
  <main class="bg-[#fafafa]">
    <div class="max-w-[489px] mx-auto flex flex-col min-h-screen pb-20">
      <nuxt-link to="/" class="flex-none flex justify-center mt-12">
        <img src="/favicon.svg" alt="Rintisan Logo" width="48" height="48">
      </nuxt-link>
      <div class="flex-1 flex flex-col items-center justify-center px-4">
        <div class="text-center mt-4">
          <h3 class="font-semibold text-lg">
            Snaps!
          </h3>
          <p class="text-muted-foreground text-sm mt-2">
            Halaman yang kamu tuju <br> tidak dapat ditemukan!
          </p>
        </div>
        <Button class="mt-8" @click="handleError">
          Kembali
        </Button>
      </div>
      <div class="flex-none flex justify-center text-center pb-4">
        <p class="text-muted-foreground text-sm">
          {{ error.statusCode }}
        </p>
        <p v-if="!is404" class="mt-2 text-muted-foreground text-sm">
          {{ error.message }}
        </p>
      </div>
    </div>
  </main>
</template>
